// @flow
import React from 'react';
import TextTruncate from 'react-text-truncate';
import LazyLoad from 'react-lazyload';
import Helper from '../../../helper/Helper';
import CONFIG from '../../../config';
import LocaleLink from '../LocaleLink';
import I18n from '../../../i18n/I18n';
import styles from './ProductBox.scss';

type Props = {
    product: Object,
    saleColor: string,
    layout: string,
    className: string,
    index: number | string,
};

const ProductBox = (props: Props) => {
    const product = props.product || '';
    const placeholder = (
        <img
            src={`${CONFIG.BASE_IMG_URL}nr/misc/product-image-default.jpg`}
            alt="productImage"
        />
    );

    const image = product.image_key ? (
        <div className={styles.imageContainer}>
            {props.index ? (
                <div className={styles.ranking}>#{props.index}</div>
            ) : (
                ''
            )}

            <div className={styles.productImage}>
                <LazyLoad
                    height="100%"
                    once
                    placeholder={placeholder}
                    offset={100}
                >
                    <img
                        src={Helper.getTransformationUrl(product.image_key)}
                        alt="placeholder_image"
                    />
                </LazyLoad>
            </div>
        </div>
    ) : (
        ''
    );

    const productName =
        product && product.title ? (
            <TextTruncate
                line={2}
                text={product.title}
                containerClassName={styles.productName}
            />
        ) : (
            ''
        );

    const revenue =
        product && product.product_revenue ? (
            <div className={styles.revenue}>
                <div className={styles.revenueTitle}>
                    {I18n.getText(
                        'product-box.total-revenue',
                        {},
                        'Total Revenue',
                    )}
                </div>
                <div>
                    {I18n.formatCurrency(
                        Helper.formatPrice(
                            product.product_revenue,
                            props.currencyCode,
                        ),
                    )}
                </div>
            </div>
        ) : (
            ''
        );

    return (
        <a
            target="_blank"
            href={`${Helper.getAppDomain(
                'catalog',
            )}/${Helper.getLocale()}/catalog/${product.psku_canonical}`}
            className={`${styles.mainContainer}`}
        >
            <div className={styles.imageWrapper}>{image}</div>
            <div className={styles.productDesc}>
                {productName}
                {revenue}
            </div>
        </a>
    );
};

export default ProductBox;



// WEBPACK FOOTER //
// ./src/components/common/productBox/ProductBox.js